// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: flex;
      justify-content: center;
    width: 95vw;
    margin-left: 2.5vw;
    
  }


  .button-container {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
  
  .translation-list {
    margin-top: 2rem;
  }
  
  table {
    width: 100%;
  }
  
  .mat-column-actions {
    width: 120px;
    text-align: center;
  }
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRyYW5zbGF0aW9uLXNlcnZpY2UtdG9vbHMtZWRpdG9yLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxhQUFhO01BQ1gsdUJBQXVCO0lBQ3pCLFdBQVc7SUFDWCxrQkFBa0I7O0VBRXBCOzs7RUFHQTtJQUNFLGFBQWE7SUFDYixTQUFTO0lBQ1QsZ0JBQWdCO0lBQ2hCLG1CQUFtQjtFQUNyQjs7RUFFQTtJQUNFLGdCQUFnQjtFQUNsQjs7RUFFQTtJQUNFLFdBQVc7RUFDYjs7RUFFQTtJQUNFLFlBQVk7SUFDWixrQkFBa0I7RUFDcEIiLCJmaWxlIjoidHJhbnNsYXRpb24tc2VydmljZS10b29scy1lZGl0b3IuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgd2lkdGg6IDk1dnc7XG4gICAgbWFyZ2luLWxlZnQ6IDIuNXZ3O1xuICAgIFxuICB9XG5cblxuICAuYnV0dG9uLWNvbnRhaW5lciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBnYXA6IDFyZW07XG4gICAgbWFyZ2luLXRvcDogMXJlbTtcbiAgICBtYXJnaW4tYm90dG9tOiAycmVtO1xuICB9XG4gIFxuICAudHJhbnNsYXRpb24tbGlzdCB7XG4gICAgbWFyZ2luLXRvcDogMnJlbTtcbiAgfVxuICBcbiAgdGFibGUge1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG4gIFxuICAubWF0LWNvbHVtbi1hY3Rpb25zIHtcbiAgICB3aWR0aDogMTIwcHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB9Il19 */`, "",{"version":3,"sources":["webpack://./src/app/components/translation-service-tools/translation-service-tools-editor/translation-service-tools-editor.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;MACX,uBAAuB;IACzB,WAAW;IACX,kBAAkB;;EAEpB;;;EAGA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF,wjCAAwjC","sourcesContent":[":host {\n    display: flex;\n      justify-content: center;\n    width: 95vw;\n    margin-left: 2.5vw;\n    \n  }\n\n\n  .button-container {\n    display: flex;\n    gap: 1rem;\n    margin-top: 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .translation-list {\n    margin-top: 2rem;\n  }\n  \n  table {\n    width: 100%;\n  }\n  \n  .mat-column-actions {\n    width: 120px;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
